import { render, staticRenderFns } from "./layout-builder.vue?vue&type=template&id=5d8bb964&scoped=true"
import script from "./layout-builder.vue?vue&type=script&lang=js"
export * from "./layout-builder.vue?vue&type=script&lang=js"
import style0 from "./layout-builder.vue?vue&type=style&index=0&id=5d8bb964&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8bb964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4220330617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8bb964')) {
      api.createRecord('5d8bb964', component.options)
    } else {
      api.reload('5d8bb964', component.options)
    }
    module.hot.accept("./layout-builder.vue?vue&type=template&id=5d8bb964&scoped=true", function () {
      api.rerender('5d8bb964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/layout-builder.vue"
export default component.exports